import { render, staticRenderFns } from "./BlogCommentItem.vue?vue&type=template&id=1b3017aa&scoped=true"
import script from "./BlogCommentItem.vue?vue&type=script&lang=js"
export * from "./BlogCommentItem.vue?vue&type=script&lang=js"
import style0 from "./BlogCommentItem.vue?vue&type=style&index=0&id=1b3017aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3017aa",
  null
  
)

export default component.exports